module.exports = __webpack_public_path__ + "img/cz.859f18a5.svg";